// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, MutableRefObject, useEffect, useState} from 'react';
// @ts-ignore
// import {createRoot} from 'react-dom-client';
import cn from 'classnames';
import zdot from '/util/zdot.js';
// @ts-ignore
import cs_nodejs from 'text!./code_snippets/nodejs.txt';
// @ts-ignore
import cs_curl from 'text!./code_snippets/curl.txt';
// @ts-ignore
import cs_go from 'text!./code_snippets/go.txt';
// @ts-ignore
import cs_php from 'text!./code_snippets/php.txt';
// @ts-ignore
import cs_python3 from 'text!./code_snippets/python3.txt';
import styles from './code_snippet2.module.less';
// @ts-ignore
import {Tooltip} from '../../../../hola/pub/lib/tooltip';
import Copy from '../../../pub/img/icons/16/Copy.svg';
import Check from '../../../pub/img/icons/16/check.svg';

const cs_targets = {
    nodejs: cs_nodejs,
    curl: cs_curl,
    go: cs_go,
    php: cs_php,
    python3: cs_python3,
};

export type t_target = keyof typeof cs_targets;
export interface i_proxy {
    host: string;
    port: string;
    login: string;
    password: string;
}

interface i_highlight {
    text: string;
    hint: JSX.Element | string;
}

export type i_highlights = object_of<i_highlight>;
interface i_code_snippet_props {
    target: t_target;
    proxy: i_proxy;
    highlights?: i_highlights;
    tmpl?: string;
    on_text_change?: (text: string)=>void;
}

interface i_part_with_tooltip_props {
    type: string;
    text: string;
}

// const Part_with_tooltip = ({type, text}: i_part_with_tooltip_props)=>{
//     const [copied, set_copied] = useState(false);
//     const handle_copy = ()=>{
//         navigator.clipboard.writeText(text);
//         set_copied(true);
//         setTimeout(()=>{
//             set_copied(false);
//         }, 2000);
//     };
//     return <Tooltip
//       cls={type=='country' && styles.my_bg}
//       content={
//         <div className={styles.new_hint}>
//           <span className={cn(styles.hint_span, styles[`hint_s_${type}`])}>
//             {type}
//           </span>
//           <span className={cn(styles.copy, styles[`hint_c_${type}`])}
//             onClick={handle_copy}>
//               {copied ? <Check/> : <Copy/>}
//           </span>
//         </div>
//       }
//       cls_cn={styles.code_hint_tooltip}>
//       {text}
//   </Tooltip>;
// };

const Part_with_tooltip = ({type, text}: i_part_with_tooltip_props)=>{
    const [copied, set_copied] = useState(false);
    const handle_copy = ()=>{
        void navigator.clipboard.writeText(text)
            .then(()=>set_copied(true))
            .finally(()=>setTimeout(()=>set_copied(false), 2000));
    };
    return <Tooltip
      cls={type=='country' && styles.my_bg}
      content={
        <div className={styles.new_hint}>
          <span className={cn(styles.hint_span, styles[`hint_s_${type}`])}>
            {type}
          </span>
          <span className={cn(styles.copy, styles[`hint_c_${type}`])}
            onClick={handle_copy}>
            {copied ? <Check/> : <Copy/>}
          </span>
        </div>
      }
      cls_cn={styles.code_hint_tooltip}>
      {text}
  </Tooltip>;
};

export const Code_snippet2 = React.forwardRef((props: i_code_snippet_props,
    pre_ref: MutableRefObject<HTMLPreElement>)=>
{
    const [elements, set_elements] = useState([]);
    const {target, proxy = {}, on_text_change, highlights, tmpl} = props;
    const text = tmpl || zdot.template(cs_targets[target])(proxy) as string;
    useEffect(()=>{
        if (text && on_text_change)
            on_text_change(text);
    }, [target, proxy, text]);
    useEffect(()=>{
        if (!text)
            return;
        let html2 = text;
        let elements_for_insert = [];
        let index = 0;
        const session_text = highlights.login.text
            .match(/session-([^-]+)/)?.[1] || null;
        const country_text = highlights.login.text
            .match(/country-([^-]+)/)?.[1] || null;
        const country_session = `country-${country_text}-` +
            `session-${session_text}`;
        Object.keys(highlights).forEach(key=>{
            const h = highlights[key];
            let h_cls: string;
            if (h.text!='_login_' && h.text!='_pass_' && h.text!='_port_' &&
                h.text!='XX' && h.text!='###')
            {
                h.hint = key;
                h_cls = styles.text_highlight;
            }
            if (h.text.includes('country-'))
                h.text = h.text.replace(`-${country_session}`, '');
            // html = html.replace(h.text, m=>{
            //     return `<span class="${cn(h_cls ? h_cls :
            //         styles.highlight, styles[key])}">`
            //         +`${m}</span>`;
            // });
            html2 = html2.replace(h.text, m=>{
                index++;
                elements_for_insert.push({key, m, h_cls});
                return `**%${index}%**`;
            });
        });
        const new_elements = [];
        html2.split(`**%`).forEach((e, i)=>{
            if (i==0)
            {
                new_elements.push(e);
                return;
            }
            const str: any = e.split('%**');
            const element_for_insert = elements_for_insert[str[0]-1];
            new_elements.push(element_for_insert);
            new_elements.push(str[1]);
        });
        set_elements(new_elements);
        // pre_ref.current.innerHTML = html;
        // const highlight_elems = pre_ref.current.querySelectorAll(
        //     `.${styles.text_highlight}, .${styles.highlight}`);
        // Array.from(highlight_elems).forEach((h: HTMLSpanElement)=>{
        //     const highlight = Object.values(highlights)
        //         .find(hl=>hl.text == h.textContent);
        //     if (highlight.hint)
        //     {
        //         const hint_el = document.createElement('span');
        //         hint_el.className = styles.hint;
        //         const root = createRoot(hint_el);
        //         root.render(highlight.hint);
        //         h.appendChild(hint_el);
        //         if (highlight.hint=='login' || highlight.hint=='password' ||
        //             highlight.hint=='port' || highlight.hint=='host')
        //         {
        //             h.addEventListener('mouseenter', e=>{
        //                 if (active_hint.current)
        //                     active_hint.current.style.visibility = 'hidden';
        //                 active_hint.current = hint_el;
        //                 hint_el.style.opacity = '1';
        //                 hint_el.style.visibility = 'visible';
        //                 const rect = h.getBoundingClientRect();
        //                 const hint_rect = hint_el.getBoundingClientRect();
        //                 const hint_w = hint_rect.width;
        //                 const hint_h = hint_rect.height;
        //                 hint_el.style.left =
        //                     `${e.clientX - rect.left - hint_w / 2}px`;
        //                 hint_el.style.top =
        //                     `${e.clientY - rect.top - hint_h - 2}px`;
        //                 console.log(rect, hint_el.style.top);
        //             });
        //             h.addEventListener('mouseleave', ()=>{
        //                 hint_el.style.opacity = '0';
        //                 hint_el.style.visibility = 'hidden';
        //                 active_hint.current = null;
        //             });
        //         }
        //     }
        //     h.style.setProperty('--h_top', `${h.offsetTop}px`);
        // }, 500);
    }, [pre_ref?.current, text, highlights]);
    return <Fragment>
      <pre ref={pre_ref} className={styles.code_snippet}>
        {elements.map((el, i)=>{
          if (el.key)
            return <Part_with_tooltip key={i} type={el.key} text={el.m}/>;
          return el;
      })}</pre>
    </Fragment>;
});
